/**
 * Consent to check if exists in the user's consents
 */
const CONSENTS_TO_VALIDATE = [
  14, // RELATED
  15, // LISTING CHANGES
];

export default CONSENTS_TO_VALIDATE;
